import React from "react";

const wrapperStyle = {
    marginBottom: "20px"
};

const TextHeader = ({ heading, subHeading }) => (
    <div className="text-header-wrapper" style={wrapperStyle}>
        <h1>{heading}</h1>
        {subHeading && <p>{subHeading}</p>}
    </div>
);

export default TextHeader;



// WEBPACK FOOTER //
// ./components/misc/TextHeader.jsx